/* Pricing.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Box } from '@atlaskit/primitives';
import { Stripe } from '@atlassian/mpac-primitives';
import { MarketplaceAppPaymentModel } from '@atlassian/mpac-types/client-graphql-schema-types';
import { PaidAppPricing } from './PaidAppPricing';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _ = "._syaz131l{color:var(--ds-text-subtlest,#626f86)}";
const freePriceTextStyle = null;
export const Pricing = _ref => {
  let {
    appDetails,
    hostStatusResponse,
    installedAppDetailsResult,
    cmtAvailabilityResult,
    links
  } = _ref;
  const isFreeApp = appDetails.paymentModel === MarketplaceAppPaymentModel.Free;
  if (isFreeApp) {
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_syaz131l"]),
        children: "Free"
      })]
    });
  }
  if (hostStatusResponse.hostStatusLoading) {
    return /*#__PURE__*/_jsx(Stripe, {
      width: "5rem",
      height: "0.875rem",
      marginTop: "var(--ds-space-075, 6px)"
    });
  }
  if (hostStatusResponse.hostStatusError || !hostStatusResponse.hostStatusResult) {
    return /*#__PURE__*/_jsx(Box, {
      children: "Unknown Price"
    });
  }
  return /*#__PURE__*/_jsx(PaidAppPricing, {
    appDetails: appDetails,
    hostStatus: hostStatusResponse.hostStatusResult,
    installedAppDetailsResult: installedAppDetailsResult,
    cmtAvailabilityResult: cmtAvailabilityResult,
    links: links
  });
};